import React, { useEffect } from 'react'
import useForm from 'react-hook-form'
import { Link } from 'react-router-dom'
import { connect } from 'react-redux'
import ReactLoading from 'react-loading'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { withRouter } from 'react-router-dom'
import { faFolder, faAngleLeft } from '@fortawesome/free-solid-svg-icons'
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  Row,
  Col,
  Container
} from 'reactstrap'
import PropTypes from 'prop-types'
import { fetchProject, updateProject } from 'redux/actions/projects'
import ProjectForm from 'components/Projects/form'
import BackButton from 'components/BackButton'

const EditProject = ({ fetchProject, updateProject, form, loading, history, match }) => {
  const { register, reset, setError, handleSubmit, errors } = useForm()
  useEffect(() => {
    fetchProject(match.params.id)
  }, [fetchProject, match])

  useEffect(() => {
    reset(form)
  }, [form, reset])

  return (
    <Container className="pt-2 pt-md-5 pt-lg-6" fluid>
      <BackButton />
      <Row>
        <Col className="order-xl-1" xl="12">
          <Card className="bg-secondary shadow">
            <CardHeader className="bg-white border-0">
              <Row className="align-items-center">
                <Col xs="12">
                  <h3 className="mb-0">
                    <FontAwesomeIcon icon={faFolder} className="mr-1"/> Editar Proyecto<br/>
                    <Button
                      tag={Link}
                      color="primary"
                      to={`/admin/projects/${match.params.id}`}
                      size="sm"
                      className="mt-2"
                    >
                      <FontAwesomeIcon icon={faAngleLeft} className="mr-2"/>
                      Cancelar
                    </Button>
                  </h3>
                </Col>
              </Row>
            </CardHeader>
            <CardBody>
              {!loading && (
                <ProjectForm
                  onSubmit={handleSubmit(params => updateProject({ ...params }, history, setError))}
                  history={history}
                  register={register}
                  errors={errors}
                />
              )}
              {loading && (
                <ReactLoading type="spinningBubbles" color="#000" height={30} width={30} className="mt-3" />
              )}
            </CardBody>
          </Card>
        </Col>
      </Row>
    </Container>
  )
}

const mapStateToProps = ({ projects: { form, loadingProject } }) => ({
  form,
  loading: loadingProject
})

const mapDispatchToProps = dispatch => ({
  fetchProject: id => dispatch(fetchProject(id)),
  updateProject: (values, history) => dispatch(updateProject(values, history)),
})

EditProject.propTypes = {
  form: PropTypes.shape({
    address: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
  }),
  loading: PropTypes.bool,
  fetchProject: PropTypes.func.isRequired,
  updateProject: PropTypes.func.isRequired,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired
  }).isRequired,
  match: PropTypes.shape({
    params: PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired
    }).isRequired
  }).isRequired,
}

EditProject.defaultProps = {
  loading: false,
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(EditProject))
